<template>
	<table class="list_tb">
        <colgroup>
            <slot name="col" />
        </colgroup>
        <thead>
            <tr>
                <slot name="header" />
            </tr>
        </thead>
        <tbody>
            <slot name="notice" /> <!-- <tr class="notice"> 로 만들어야 함 -->
            <slot name="list" />
        </tbody>
    </table>
</template>

<script>
export default {
	props: {
		
	},
    data() {
        return {
            
        }
    },
    methods: {

    }
}
</script>
